(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;
    var closeBtn = bar.querySelector('[data-announcement-close]');
    if (!closeBtn) return;

    closeBtn.addEventListener('click', function () {
      var expires = new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString();
      document.cookie = 'skopos_announcement_dismissed=1; expires=' + expires + '; path=/';
      document.documentElement.style.setProperty('--announcement-height', '0px');
      bar.setAttribute('hidden', '');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
(function () {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var bodyEl = drawer.querySelector('.cart-drawer__body');
  var footerEl = drawer.querySelector('.cart-drawer__footer');
  var countEl = drawer.querySelector('.cart-drawer__count');
  var totalEl = drawer.querySelector('.cart-drawer__total-value');
  var shippingEl = drawer.querySelector('.cart-drawer__shipping');
  var shippingFill = drawer.querySelector('.cart-drawer__shipping-fill');
  var shippingLabel = drawer.querySelector('.cart-drawer__shipping-label');
  var upsellRow = drawer.querySelector('.cart-drawer__upsell-row');

  var moneyFormat = drawer.getAttribute('data-money-format') || '';
  var emptyText = drawer.getAttribute('data-empty-text') || '';
  var emptyCtaLabel = drawer.getAttribute('data-empty-cta-label') || '';
  var emptyCtaLink = drawer.getAttribute('data-empty-cta-link') || '/';
  var itemTagline = drawer.getAttribute('data-item-tagline') || '';
  var removeLabel = drawer.getAttribute('data-remove-label') || 'Remove';

  // Parse multi-threshold config
  var rawThresholds = (drawer.getAttribute('data-thresholds') || '').split(',');
  var rawProgress = (drawer.getAttribute('data-progress-texts') || '').split(',');
  var rawUnlocked = (drawer.getAttribute('data-unlocked-texts') || '').split(',');

  var thresholds = [];
  for (var ti = 0; ti < 3; ti++) {
    var val = parseFloat(rawThresholds[ti]) || 0;
    if (val > 0) {
      thresholds.push({
        cents: val * 100,
        progress: rawProgress[ti] || '',
        unlocked: rawUnlocked[ti] || '',
        milestoneEl: drawer.querySelector('[data-milestone="' + (ti + 1) + '"]')
      });
    }
  }

  var CHECK_SVG = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.5 6.3l2.3 2.4 4.7-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var lastTrigger = null;
  var busy = false;

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(n, p, t, d) {
      p = p == null ? 2 : p; t = t || ','; d = d || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(p);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      return dollars + (parts[1] ? d + parts[1] : '');
    }
    var match = moneyFormat.match(placeholder);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return match ? moneyFormat.replace(placeholder, value) : value;
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function sizedImage(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=144';
  }

  function emptyHtml() {
    return '<div class="cart-drawer__empty">' +
      '<p class="cart-drawer__empty-text">' + escapeHtml(emptyText) + '</p>' +
      '<a class="cart-drawer__button cart-drawer__button--shop" href="' + escapeHtml(emptyCtaLink) + '">' + escapeHtml(emptyCtaLabel) + '</a>' +
      '</div>';
  }

  function itemProperties(item) {
    if (!item.properties) return '';
    var parts = [];
    Object.keys(item.properties).forEach(function(key) {
      if (key.charAt(0) === '_') return;
      var val = item.properties[key];
      if (val === null || val === undefined || val === '') return;
      parts.push(escapeHtml(String(val)));
    });
    return parts.length ? '<p class="cart-drawer__item-desc">' + parts.join(' · ') + '</p>' : '';
  }

  function itemRow(item) {
    var img = sizedImage(item.image);
    var imgTag = img
      ? '<img class="cart-drawer__item-image" src="' + escapeHtml(img) + '" alt="' + escapeHtml(item.product_title) + '" width="72" height="72" loading="lazy">'
      : '<span class="cart-drawer__item-image"></span>';
    var tagline = itemTagline ? '<p class="cart-drawer__item-tagline">' + escapeHtml(itemTagline) + '</p>' : '';
    var variant = item.variant_title ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>' : '';
    return '<li class="cart-drawer__item" data-line-key="' + escapeHtml(item.key) + '">' +
      '<a class="cart-drawer__item-image-link" href="' + escapeHtml(item.url) + '">' + imgTag + '</a>' +
      '<div class="cart-drawer__item-main">' +
        '<button type="button" class="cart-drawer__remove" data-qty-action="remove">' + escapeHtml(removeLabel) + '</button>' +
        '<a class="cart-drawer__item-title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
        tagline + variant + itemProperties(item) +
        '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
        '<div class="cart-drawer__qty">' +
          '<button type="button" class="cart-drawer__qty-btn" data-qty-action="decrease" aria-label="Decrease"' + (item.quantity <= 1 ? ' disabled' : '') + '>&minus;</button>' +
          '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
          '<button type="button" class="cart-drawer__qty-btn" data-qty-action="increase" aria-label="Increase">+</button>' +
        '</div>' +
      '</div>' +
    '</li>';
  }

  function renderShipping(totalPrice) {
    if (!thresholds.length) return;

    // Find the active (next unpassed) threshold
    var activeIdx = -1;
    for (var i = 0; i < thresholds.length; i++) {
      thresholds[i].milestoneEl && thresholds[i].milestoneEl.classList.toggle('is-unlocked', totalPrice >= thresholds[i].cents);
      if (activeIdx === -1 && totalPrice < thresholds[i].cents) activeIdx = i;
    }

    // Determine progress bar range
    var prevCents = activeIdx > 0 ? thresholds[activeIdx - 1].cents : 0;
    var nextCents = activeIdx > -1 ? thresholds[activeIdx].cents : thresholds[thresholds.length - 1].cents;
    var pct;
    if (activeIdx === -1) {
      pct = 100;
    } else {
      pct = Math.min(100, ((totalPrice - prevCents) / (nextCents - prevCents)) * 100);
    }
    shippingFill.style.width = pct + '%';

    if (activeIdx === -1) {
      // All thresholds passed — show last unlocked message
      var last = thresholds[thresholds.length - 1];
      shippingLabel.classList.add('is-unlocked');
      shippingLabel.innerHTML = CHECK_SVG + '<span>' + escapeHtml(last.unlocked) + '</span>';
    } else {
      var active = thresholds[activeIdx];
      var remaining = active.cents - totalPrice;
      var msg = active.progress.replace('[remaining]', formatMoney(remaining));
      shippingLabel.classList.remove('is-unlocked');
      shippingLabel.innerHTML = '<span>' + escapeHtml(msg) + '</span>';
    }
  }

  function updateCount(count) {
    var headerBadge = document.querySelector('[data-cart-count]');
    if (headerBadge) { headerBadge.textContent = count; headerBadge.hidden = count === 0; }
    if (countEl) { countEl.textContent = count; countEl.hidden = count === 0; }
  }

  function render(cart) {
    var empty = cart.item_count === 0;
    if (empty) {
      bodyEl.innerHTML = emptyHtml();
    } else {
      bodyEl.innerHTML = '<ul class="cart-drawer__items" role="list">' + cart.items.map(itemRow).join('') + '</ul>';
      totalEl.innerHTML = formatMoney(cart.total_price);
      if (thresholds.length) {
        shippingEl.hidden = false;
        renderShipping(cart.total_price);
      }
    }
    footerEl.hidden = empty;
    if (!thresholds.length) shippingEl.hidden = true;
    if (empty) shippingEl.hidden = true;
    updateCount(cart.item_count);
  }

  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  function fetchCart() {
    return fetch(cartUrl('/cart.js'), { headers: { 'Accept': 'application/json' } }).then(function(r) {
      if (!r.ok) throw new Error('Could not load cart');
      return r.json();
    });
  }

  function applyCart(mutation) {
    if (busy) return;
    busy = true;
    drawer.classList.add('is-busy');
    mutation.then(function() { return fetchCart(); })
      .then(function(cart) { render(cart); showDrawer(); document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart })); })
      .catch(function(err) { console.error('[cart-drawer]', err); })
      .then(function() { busy = false; drawer.classList.remove('is-busy'); });
  }

  function changeLine(key, quantity) {
    applyCart(fetch(cartUrl('/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(r) { if (!r.ok) return r.json().then(function(e) { throw new Error(e.description); }); return r.json(); }));
  }

  function addVariant(variantId) {
    if (!variantId) return;
    applyCart(fetch(cartUrl('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function(r) { if (!r.ok) return r.json().then(function(e) { throw new Error(e.description); }); return r.json(); }));
  }

  function showDrawer() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }

  function openDrawer() {
    showDrawer();
    if (countEl) countEl.focus ? undefined : undefined;
    fetchCart().then(render).catch(function(err) { console.error('[cart-drawer]', err); });
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastTrigger) lastTrigger.focus();
  }

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-cart-trigger]');
    if (trigger) { e.preventDefault(); lastTrigger = trigger; openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    if (e.target.closest('[data-upsell-prev]') && upsellRow) { upsellRow.scrollBy({ left: -212, behavior: 'smooth' }); return; }
    if (e.target.closest('[data-upsell-next]') && upsellRow) { upsellRow.scrollBy({ left: 212, behavior: 'smooth' }); return; }
    var upsellBtn = e.target.closest('[data-upsell-add]');
    if (upsellBtn && drawer.contains(upsellBtn)) { addVariant(upsellBtn.getAttribute('data-variant-id')); return; }
    var qtyBtn = e.target.closest('[data-qty-action]');
    if (qtyBtn && drawer.contains(qtyBtn)) {
      var row = qtyBtn.closest('.cart-drawer__item');
      if (!row) return;
      var key = row.getAttribute('data-line-key');
      var current = parseInt(row.querySelector('.cart-drawer__qty-value').textContent, 10) || 0;
      var action = qtyBtn.getAttribute('data-qty-action');
      if (action === 'increase') changeLine(key, current + 1);
      else if (action === 'decrease' && current > 1) changeLine(key, current - 1);
      else if (action === 'remove') changeLine(key, 0);
    }
  });

  document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
  document.addEventListener('cart-drawer:open', function() { openDrawer(); });
  document.addEventListener('cart:refresh', function() { fetchCart().then(render).catch(function(e) { console.error('[cart-drawer]', e); }); });

  fetchCart().then(render).catch(function(err) { console.error('[cart-drawer] initial load failed:', err); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaq(section) {
      section.querySelectorAll('.faq__question').forEach(function (btn) {
        var item = btn.closest('.faq__item');
        if (!item) return;
        var panel = item.querySelector('.faq__panel');
        if (!panel) return;

        btn.addEventListener('click', function () {
          var isOpen = item.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
        });
      });
    }

    document.querySelectorAll('.faq').forEach(initFaq);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var drawer = document.getElementById('nav-drawer');
    var hamburger = document.querySelector('.header__hamburger');
    if (!drawer || !hamburger) return;

    var closeBtn = drawer.querySelector('.nav-drawer__close');
    var backdrop = drawer.querySelector('.nav-drawer__backdrop');

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      hamburger.focus();
    }

    hamburger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-page"]) return;
  try {
    
(function () {
  var page = document.getElementById('cart-page');
  if (!page) return;

  var bodyEl = page.querySelector('.cart-page__body');
  var footerEl = page.querySelector('.cart-page__footer');
  var countEl = page.querySelector('.cart-page__count');
  var totalEl = page.querySelector('.cart-page__total-value');
  var shippingEl = page.querySelector('.cart-page__shipping');
  var shippingFill = page.querySelector('.cart-page__shipping-fill');
  var shippingLabel = page.querySelector('.cart-page__shipping-label');
  var upsellRow = page.querySelector('.cart-page__upsell-row');

  var moneyFormat = page.getAttribute('data-money-format') || '';
  var emptyText = page.getAttribute('data-empty-text') || '';
  var emptyCtaLabel = page.getAttribute('data-empty-cta-label') || '';
  var emptyCtaLink = page.getAttribute('data-empty-cta-link') || '/';
  var itemTagline = page.getAttribute('data-item-tagline') || '';
  var removeLabel = page.getAttribute('data-remove-label') || 'Remove';

  var rawThresholds = (page.getAttribute('data-thresholds') || '').split(',');
  var rawProgress = (page.getAttribute('data-progress-texts') || '').split(',');
  var rawUnlocked = (page.getAttribute('data-unlocked-texts') || '').split(',');

  var thresholds = [];
  for (var ti = 0; ti < 3; ti++) {
    var val = parseFloat(rawThresholds[ti]) || 0;
    if (val > 0) {
      thresholds.push({
        cents: val * 100,
        progress: rawProgress[ti] || '',
        unlocked: rawUnlocked[ti] || '',
        milestoneEl: page.querySelector('[data-milestone="' + (ti + 1) + '"]')
      });
    }
  }

  var CHECK_SVG = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.5 6.3l2.3 2.4 4.7-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var busy = false;

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(n, p, t, d) {
      p = p == null ? 2 : p; t = t || ','; d = d || '.';
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(p);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t);
      return dollars + (parts[1] ? d + parts[1] : '');
    }
    var match = moneyFormat.match(placeholder);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return match ? moneyFormat.replace(placeholder, value) : value;
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function sizedImage(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=176';
  }

  function emptyHtml() {
    return '<div class="cart-page__empty">' +
      '<p class="cart-page__empty-text">' + escapeHtml(emptyText) + '</p>' +
      '<a class="cart-page__button cart-page__button--shop" href="' + escapeHtml(emptyCtaLink) + '">' + escapeHtml(emptyCtaLabel) + '</a>' +
      '</div>';
  }

  function itemProperties(item) {
    if (!item.properties) return '';
    var parts = [];
    Object.keys(item.properties).forEach(function(key) {
      if (key.charAt(0) === '_') return;
      var val = item.properties[key];
      if (val === null || val === undefined || val === '') return;
      parts.push(escapeHtml(String(val)));
    });
    return parts.length ? '<p class="cart-page__item-desc">' + parts.join(' · ') + '</p>' : '';
  }

  function itemRow(item) {
    var img = sizedImage(item.image);
    var imgTag = img
      ? '<img class="cart-page__item-image" src="' + escapeHtml(img) + '" alt="' + escapeHtml(item.product_title) + '" width="88" height="88" loading="lazy">'
      : '<span class="cart-page__item-image"></span>';
    var tagline = itemTagline ? '<p class="cart-page__item-tagline">' + escapeHtml(itemTagline) + '</p>' : '';
    var variant = item.variant_title ? '<p class="cart-page__item-variant">' + escapeHtml(item.variant_title) + '</p>' : '';
    return '<li class="cart-page__item" data-line-key="' + escapeHtml(item.key) + '">' +
      '<a class="cart-page__item-image-link" href="' + escapeHtml(item.url) + '">' + imgTag + '</a>' +
      '<div class="cart-page__item-main">' +
        '<button type="button" class="cart-page__remove" data-qty-action="remove">' + escapeHtml(removeLabel) + '</button>' +
        '<a class="cart-page__item-title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
        tagline + variant + itemProperties(item) +
        '<span class="cart-page__item-price">' + formatMoney(item.final_line_price) + '</span>' +
        '<div class="cart-page__qty">' +
          '<button type="button" class="cart-page__qty-btn" data-qty-action="decrease" aria-label="Decrease"' + (item.quantity <= 1 ? ' disabled' : '') + '>&minus;</button>' +
          '<span class="cart-page__qty-value">' + item.quantity + '</span>' +
          '<button type="button" class="cart-page__qty-btn" data-qty-action="increase" aria-label="Increase">+</button>' +
        '</div>' +
      '</div>' +
    '</li>';
  }

  function renderShipping(totalPrice) {
    if (!thresholds.length) return;
    var activeIdx = -1;
    for (var i = 0; i < thresholds.length; i++) {
      thresholds[i].milestoneEl && thresholds[i].milestoneEl.classList.toggle('is-unlocked', totalPrice >= thresholds[i].cents);
      if (activeIdx === -1 && totalPrice < thresholds[i].cents) activeIdx = i;
    }
    var prevCents = activeIdx > 0 ? thresholds[activeIdx - 1].cents : 0;
    var nextCents = activeIdx > -1 ? thresholds[activeIdx].cents : thresholds[thresholds.length - 1].cents;
    var pct;
    if (activeIdx === -1) {
      pct = 100;
    } else {
      pct = Math.min(100, ((totalPrice - prevCents) / (nextCents - prevCents)) * 100);
    }
    shippingFill.style.width = pct + '%';

    if (activeIdx === -1) {
      var last = thresholds[thresholds.length - 1];
      shippingLabel.classList.add('is-unlocked');
      shippingLabel.innerHTML = CHECK_SVG + '<span>' + escapeHtml(last.unlocked) + '</span>';
    } else {
      var active = thresholds[activeIdx];
      var remaining = active.cents - totalPrice;
      var msg = active.progress.replace('[remaining]', formatMoney(remaining));
      shippingLabel.classList.remove('is-unlocked');
      shippingLabel.innerHTML = '<span>' + escapeHtml(msg) + '</span>';
    }
  }

  function updateCount(count) {
    var headerBadge = document.querySelector('[data-cart-count]');
    if (headerBadge) { headerBadge.textContent = count; headerBadge.hidden = count === 0; }
    if (countEl) { countEl.textContent = count; countEl.hidden = count === 0; }
  }

  function render(cart) {
    var empty = cart.item_count === 0;
    if (empty) {
      bodyEl.innerHTML = emptyHtml();
    } else {
      bodyEl.innerHTML = '<ul class="cart-page__items" role="list">' + cart.items.map(itemRow).join('') + '</ul>';
      totalEl.innerHTML = formatMoney(cart.total_price);
      if (thresholds.length) {
        shippingEl.hidden = false;
        renderShipping(cart.total_price);
      }
    }
    footerEl.hidden = empty;
    if (!thresholds.length) shippingEl.hidden = true;
    if (empty) shippingEl.hidden = true;
    updateCount(cart.item_count);
  }

  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  function fetchCart() {
    return fetch(cartUrl('/cart.js'), { headers: { 'Accept': 'application/json' } }).then(function(r) {
      if (!r.ok) throw new Error('Could not load cart');
      return r.json();
    });
  }

  function applyCart(mutation) {
    if (busy) return;
    busy = true;
    page.classList.add('is-busy');
    mutation.then(function() { return fetchCart(); })
      .then(function(cart) { render(cart); document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart })); document.dispatchEvent(new CustomEvent('cart:refresh')); })
      .catch(function(err) { console.error('[cart-page]', err); })
      .then(function() { busy = false; page.classList.remove('is-busy'); });
  }

  function changeLine(key, quantity) {
    applyCart(fetch(cartUrl('/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(r) { if (!r.ok) return r.json().then(function(e) { throw new Error(e.description); }); return r.json(); }));
  }

  function addVariant(variantId) {
    if (!variantId) return;
    applyCart(fetch(cartUrl('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function(r) { if (!r.ok) return r.json().then(function(e) { throw new Error(e.description); }); return r.json(); }));
  }

  page.addEventListener('click', function(e) {
    if (e.target.closest('[data-upsell-prev]') && upsellRow) { upsellRow.scrollBy({ left: -220, behavior: 'smooth' }); return; }
    if (e.target.closest('[data-upsell-next]') && upsellRow) { upsellRow.scrollBy({ left: 220, behavior: 'smooth' }); return; }
    var upsellBtn = e.target.closest('[data-upsell-add]');
    if (upsellBtn && page.contains(upsellBtn)) { addVariant(upsellBtn.getAttribute('data-variant-id')); return; }
    var qtyBtn = e.target.closest('[data-qty-action]');
    if (qtyBtn && page.contains(qtyBtn)) {
      var row = qtyBtn.closest('.cart-page__item');
      if (!row) return;
      var key = row.getAttribute('data-line-key');
      var current = parseInt(row.querySelector('.cart-page__qty-value').textContent, 10) || 0;
      var action = qtyBtn.getAttribute('data-qty-action');
      if (action === 'increase') changeLine(key, current + 1);
      else if (action === 'decrease' && current > 1) changeLine(key, current - 1);
      else if (action === 'remove') changeLine(key, 0);
    }
  });

  document.addEventListener('cart:refresh', function() { fetchCart().then(render).catch(function(e) { console.error('[cart-page]', e); }); });

  fetchCart().then(render).catch(function(err) { console.error('[cart-page] initial load failed:', err); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plinko-popup"]) return;
  try {
    
  (function () {
    var configEl = document.getElementById('plinko-config');
    if (!configEl) return;

    var config = JSON.parse(configEl.textContent);
    var popup  = document.getElementById('plinko-popup');
    if (!popup) return;

    /* ── Prizes & weights ──────────────────────────────────────────────
       Symmetric layout: 5 10 20 [30] 20 10 5
       Weights sum to 100; 30% is centre (most likely in real Plinko).
       Combined: 5%→6%, 10%→16%, 20%→44%, 30%→34%
    ───────────────────────────────────────────────────────────────────── */
    var PRIZES      = [5, 10, 20, 30, 20, 10, 5];
    var WEIGHTS     = [3,  8, 22, 34, 22,  8, 3];
    var NUM_BUCKETS = 7;
    var PEG_ROWS    = 8;

    var wonBucket = null;
    var wonPrize  = null;
    var wonCode   = null;

    /* ── Cookie helpers ─────────────────────────────────────────────── */
    function getCookie(name) {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
      return m ? m[1] : null;
    }
    function setCookie(name, value, days) {
      var exp = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = name + '=' + value + '; expires=' + exp + '; path=/; SameSite=Lax';
    }

    /* ── Screen routing ─────────────────────────────────────────────── */
    /* The quiz step is a full-screen takeover; every other step is the
       regular centered card. */
    function showScreen(id) {
      document.querySelectorAll('.plinko-screen').forEach(function (s) {
        s.hidden = s.id !== id;
      });
      popup.classList.toggle('plinko-popup--takeover', id === 'plinko-screen-quiz');
    }

    /* ── Cart attribute stamp ───────────────────────────────────────── */
    /* Writes cart attributes (plinko_code, focus_type) so they survive into
       checkout + abandoned-checkout, where Shopify Flow branches on them.
       Fire-and-forget; re-run on every page load while the cookies live,
       so carts created AFTER the win still get stamped. */
    function stampCartAttributes(attrs) {
      var keys = Object.keys(attrs).filter(function (k) { return !!attrs[k]; });
      if (!keys.length) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var current = (cart && cart.attributes) || {};
          var missing = {};
          keys.forEach(function (k) {
            if (current[k] !== attrs[k]) missing[k] = attrs[k];
          });
          if (!Object.keys(missing).length) return;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: missing })
          });
        })
        .catch(function () {});
    }

    /* ── Open / close ───────────────────────────────────────────────── */
    function openPopup() {
      popup.hidden = false;
      document.body.style.overflow = 'hidden';
      var tab = document.getElementById('plinko-reopen-tab');
      if (tab) tab.hidden = true;
    }
    function closePopup() {
      popup.hidden = true;
      document.body.style.overflow = '';
      setCookie('skopos_plinko_seen', '1', 30);
      var tab = document.getElementById('plinko-reopen-tab');
      if (tab) tab.hidden = false;
    }

    /* ── Weighted random bucket ─────────────────────────────────────── */
    function pickBucket() {
      var total = WEIGHTS.reduce(function (a, b) { return a + b; }, 0);
      var r = Math.random() * total;
      for (var i = 0; i < WEIGHTS.length; i++) {
        r -= WEIGHTS[i];
        if (r <= 0) return i;
      }
      return WEIGHTS.length - 1;
    }

    /* ── Canvas helpers ─────────────────────────────────────────────── */
    var INK    = '#1A1814';
    var BG     = '#F5F2EC';
    var MUTED  = '#7A7469';
    var AMBER  = '#C8561A';
    var RULE   = '#E8E3DA';
    var PEG_R  = 6;
    var BALL_R = 10;

    /* Scale canvas bitmap by devicePixelRatio so it's crisp on retina screens.
       Returns a context pre-scaled to logical (CSS) pixels. */
    function setupCanvas(canvas) {
      var dpr  = window.devicePixelRatio || 1;
      var rect = canvas.getBoundingClientRect();
      var W    = Math.round(rect.width  > 0 ? rect.width  : canvas.width);
      var H    = Math.round(rect.height > 0 ? rect.height : canvas.height);
      canvas.width  = W * dpr;
      canvas.height = H * dpr;
      var ctx = canvas.getContext('2d');
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      return ctx;
    }

    function buildPegs(W, H, bucketW, bucketCenters, PEG_ROWS, PEG_TOP, rowH) {
      var pegs = [];
      for (var row = 0; row < PEG_ROWS; row++) {
        var y = PEG_TOP + row * rowH;
        if (row % 2 === 0) {
          // 6 pegs on bucket borders (between the 7 buckets)
          for (var c = 0; c < 6; c++) {
            pegs.push({ x: bucketW * (c + 1), y: y });
          }
        } else {
          // 5 pegs at interior bucket centres — skip outermost to prevent ball wedging against walls
          for (var c = 1; c < 6; c++) {
            pegs.push({ x: bucketCenters[c], y: y });
          }
        }
      }
      return pegs;
    }

    function drawBoard(ctx, W, H, pegs, bucketW, bucketCenters, PEG_BOTTOM, highlightBucket) {
      ctx.fillStyle = BG;
      ctx.fillRect(0, 0, W, H);

      // Bucket walls
      ctx.strokeStyle = RULE;
      ctx.lineWidth = 1;
      for (var i = 0; i <= NUM_BUCKETS; i++) {
        ctx.beginPath();
        ctx.moveTo(i * bucketW, PEG_BOTTOM);
        ctx.lineTo(i * bucketW, H - 4);
        ctx.stroke();
      }

      // Bucket labels
      ctx.font = '500 10px "DM Mono", monospace';
      ctx.textAlign = 'center';
      PRIZES.forEach(function (prize, i) {
        ctx.fillStyle = (highlightBucket === i) ? AMBER : MUTED;
        ctx.fillText(prize + '%', bucketCenters[i], H - 10);
      });

      // Pegs
      pegs.forEach(function (peg) {
        ctx.beginPath();
        ctx.arc(peg.x, peg.y, PEG_R, 0, Math.PI * 2);
        ctx.fillStyle = INK;
        ctx.fill();
      });
    }

    function shuffleArr(arr) {
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
      }
      return arr;
    }

    /* Returns a shuffled array of ±1 deflections that lead to targetBucket. */
    function buildDeflections(targetBucket) {
      var defl = [];
      // Each right deflection moves +bucketW/2, each left -bucketW/2.
      // Starting at centre (3.5 buckets), reaching bucket b needs:
      //   rights = b + (PEG_ROWS - (NUM_BUCKETS-1)) / 2
      var rights = targetBucket + (PEG_ROWS - (NUM_BUCKETS - 1)) / 2;
      var lefts  = PEG_ROWS - rights;
      for (var i = 0; i < rights; i++) defl.push( 1);
      for (var i = 0; i < lefts;  i++) defl.push(-1);
      return shuffleArr(defl);
    }

    function makeBoardParams(canvas) {
      var dpr = window.devicePixelRatio || 1;
      var W = canvas.width / dpr, H = canvas.height / dpr;
      var bucketW      = W / NUM_BUCKETS;
      var bucketCenters = PRIZES.map(function (_, i) { return i * bucketW + bucketW / 2; });
      var PEG_TOP      = 52;
      var PEG_BOTTOM   = H - 62;
      var rowH         = (PEG_BOTTOM - PEG_TOP) / PEG_ROWS;
      var pegs         = buildPegs(W, H, bucketW, bucketCenters, PEG_ROWS, PEG_TOP, rowH);
      return { W: W, H: H, bucketW: bucketW, bucketCenters: bucketCenters,
               PEG_TOP: PEG_TOP, PEG_BOTTOM: PEG_BOTTOM, rowH: rowH, pegs: pegs };
    }

    var RELEASE_Y_OFFSET = 30;

    function drawIdleBoard(canvas) {
      var ctx = setupCanvas(canvas);
      var p   = makeBoardParams(canvas);
      ctx.clearRect(0, 0, p.W, p.H);
      drawBoard(ctx, p.W, p.H, p.pegs, p.bucketW, p.bucketCenters, p.PEG_BOTTOM, null);
      ctx.beginPath();
      ctx.arc(p.W / 2, p.PEG_TOP - RELEASE_Y_OFFSET, BALL_R, 0, Math.PI * 2);
      ctx.fillStyle = AMBER;
      ctx.fill();
    }

    /* ── Fallback physics (kinematic, no Matter.js dependency) ─────── */
    function runAnimationFallback(canvas, onDone) {
      var ctx = setupCanvas(canvas);
      var p   = makeBoardParams(canvas);

      /* Random walk — retry until ball lands in bucket 2, 3 or 4 */
      var intendedX, finalBucket;
      do {
        intendedX = [p.W / 2];
        for (var r = 0; r < PEG_ROWS; r++) {
          var nx = intendedX[r] + (Math.random() < 0.5 ? 1 : -1) * (p.bucketW / 2);
          nx = Math.max(p.bucketW * 0.5, Math.min(p.W - p.bucketW * 0.5, nx));
          intendedX.push(nx);
        }
        finalBucket = Math.floor(intendedX[PEG_ROWS] / p.bucketW);
      } while (finalBucket < 2 || finalBucket > 4);

      var pegYs = [];
      for (var r = 0; r < PEG_ROWS; r++) pegYs.push(p.PEG_TOP + r * p.rowH);
      var bkX = p.bucketW * finalBucket + p.bucketW / 2;
      var bkY = p.PEG_BOTTOM + 22;
      var G = 650, bx = p.W / 2, by = p.PEG_TOP - RELEASE_Y_OFFSET;
      var vx = 0, vy = 0, nr = 0, done = false, hi = false, lastTs = null;
      function aim(tx, ty) {
        var dy = ty - by; if (dy <= 0) { vx = 0; return; }
        var t = (-vy + Math.sqrt(Math.max(0, vy*vy + 2*G*dy))) / G;
        vx = t > 0.001 ? (tx - bx) / t : 0;
      }
      aim(intendedX[0], pegYs[0]);
      function frame(ts) {
        if (!lastTs) { lastTs = ts; requestAnimationFrame(frame); return; }
        var dt = Math.min((ts - lastTs) / 1000, 0.04); lastTs = ts;
        vy += G * dt; bx += vx * dt; by += vy * dt;
        while (nr < PEG_ROWS && by >= pegYs[nr]) {
          by = pegYs[nr]; bx = intendedX[nr]; vy = -Math.abs(vy) * 0.22; nr++;
          if (nr < PEG_ROWS) aim(intendedX[nr], pegYs[nr]); else aim(bkX, bkY);
        }
        if (!done && by >= bkY) { bx = bkX; by = bkY; done = true; hi = true; }
        ctx.clearRect(0, 0, p.W, p.H);
        drawBoard(ctx, p.W, p.H, p.pegs, p.bucketW, p.bucketCenters, p.PEG_BOTTOM, hi ? finalBucket : null);
        ctx.beginPath(); ctx.arc(bx, by, BALL_R, 0, Math.PI * 2); ctx.fillStyle = AMBER; ctx.fill();
        if (!done) requestAnimationFrame(frame); else setTimeout(function() { onDone(finalBucket); }, 450);
      }
      requestAnimationFrame(frame);
    }

    /* ── Matter.js physics simulation ───────────────────────────────── */
    function runAnimation(canvas, onDone) {
      if (typeof Matter === 'undefined') { runAnimationFallback(canvas, onDone); return; }

      var ctx = setupCanvas(canvas);
      var p   = makeBoardParams(canvas);
      var M   = Matter;

      /* Build an identical physics world for a given starting horizontal velocity.
         Called twice: once for the headless trial, once for the visual replay. */
      function makeWorld(startVx) {
        var engine = M.Engine.create({ gravity: { x: 0, y: 1.4 } });
        var ball   = M.Bodies.circle(p.W / 2, p.PEG_TOP - RELEASE_Y_OFFSET, BALL_R, {
          label: 'ball', restitution: 0.60, friction: 0.03, frictionAir: 0.010, density: 0.004
        });
        M.Body.setVelocity(ball, { x: startVx, y: 0 });

        var pegBodies = [];
        for (var row = 0; row < PEG_ROWS; row++) {
          var py = p.PEG_TOP + row * p.rowH;
          var cols = (row % 2 === 0)
            ? [1,2,3,4,5,6].map(function(c){ return c * p.bucketW; })
            : [1,2,3,4,5].map(function(i){ return i * p.bucketW + p.bucketW / 2; });
          cols.forEach(function(px) {
            pegBodies.push(M.Bodies.circle(px, py, PEG_R, {
              isStatic: true, label: 'peg', restitution: 0.65, friction: 0.01
            }));
          });
        }

        var wOpt = { isStatic: true, label: 'wall', friction: 0.05, restitution: 0.35 };
        var lWall = M.Bodies.rectangle(-5,      p.H / 2, 10, p.H * 2, wOpt);
        var rWall = M.Bodies.rectangle(p.W + 5, p.H / 2, 10, p.H * 2, wOpt);

        var dividers = [];
        var divTop = p.PEG_BOTTOM, divH = p.H - 4 - divTop;
        for (var i = 1; i < NUM_BUCKETS; i++) {
          dividers.push(M.Bodies.rectangle(
            i * p.bucketW, divTop + divH / 2, 4, divH,
            { isStatic: true, label: 'divider', restitution: 0.2, friction: 0.5 }
          ));
        }

        var floor = M.Bodies.rectangle(p.W / 2, p.H - 2, p.W + 20, 6, {
          isStatic: true, label: 'floor', restitution: 0.15, friction: 0.7
        });

        M.World.add(engine.world, [ball, lWall, rWall, floor].concat(pegBodies).concat(dividers));
        return { engine: engine, ball: ball };
      }

      /* Run a simulation headlessly at a fixed 16 ms step and return the
         bucket index the ball settles in. No rendering — runs in microseconds. */
      function trialDrop(startVx) {
        var w      = makeWorld(startVx);
        var engine = w.engine, ball = w.ball;
        var settle = 0, bucket = 3;
        for (var s = 0; s < 500; s++) {
          M.Engine.update(engine, 16);
          var bx  = ball.position.x, by = ball.position.y;
          var spd = Math.sqrt(ball.velocity.x * ball.velocity.x + ball.velocity.y * ball.velocity.y);
          if (by > p.PEG_BOTTOM + BALL_R && spd < 1.2) {
            if (++settle > 28) { bucket = Math.floor(bx / p.bucketW); break; }
          } else { settle = 0; }
          if (by > p.H + BALL_R * 2) { bucket = Math.floor(bx / p.bucketW); break; }
        }
        M.World.clear(engine.world, false);
        M.Engine.clear(engine);
        return Math.max(0, Math.min(NUM_BUCKETS - 1, bucket));
      }

      /* Try random starting velocities until one lands in 20% or 30% (buckets 2–4).
         Typically resolves in 1–2 attempts (~65 % of pure-physics drops already land there). */
      var startVx = 0;
      for (var attempt = 0; attempt < 20; attempt++) {
        var vx     = (Math.random() - 0.5) * 3;
        var result = trialDrop(vx);
        if (result >= 2 && result <= 4) { startVx = vx; break; }
      }

      /* Replay that exact starting condition visually using the same fixed 16 ms step.
         Because Matter.js is deterministic, the ball lands in the same bucket. */
      var w    = makeWorld(startVx);
      var engine = w.engine, world = w.engine.world, ball = w.ball;

      var done = false, settledBucket = -1, settleCount = 0;

      function frame() {
        M.Engine.update(engine, 16);

        var bx  = ball.position.x, by = ball.position.y;
        var spd = Math.sqrt(ball.velocity.x * ball.velocity.x + ball.velocity.y * ball.velocity.y);

        if (by > p.PEG_BOTTOM + BALL_R && spd < 1.2) {
          if (++settleCount > 28) {
            settledBucket = Math.max(0, Math.min(NUM_BUCKETS - 1, Math.floor(bx / p.bucketW)));
            done = true;
            M.World.clear(world, false);
            M.Engine.clear(engine);
            ctx.clearRect(0, 0, p.W, p.H);
            drawBoard(ctx, p.W, p.H, p.pegs, p.bucketW, p.bucketCenters, p.PEG_BOTTOM, settledBucket);
            ctx.beginPath(); ctx.arc(bx, by, BALL_R, 0, Math.PI * 2); ctx.fillStyle = AMBER; ctx.fill();
            setTimeout(function() { onDone(settledBucket); }, 520);
            return;
          }
        } else if (settleCount > 0) {
          settleCount = 0;
        }

        if (by > p.H + BALL_R * 2) {
          settledBucket = Math.max(0, Math.min(NUM_BUCKETS - 1, Math.floor(bx / p.bucketW)));
          M.World.clear(world, false);
          M.Engine.clear(engine);
          setTimeout(function() { onDone(settledBucket); }, 350);
          return;
        }

        ctx.clearRect(0, 0, p.W, p.H);
        drawBoard(ctx, p.W, p.H, p.pegs, p.bucketW, p.bucketCenters, p.PEG_BOTTOM, null);
        if (by < p.H + BALL_R) {
          ctx.beginPath();
          ctx.arc(bx, by, BALL_R, 0, Math.PI * 2);
          ctx.fillStyle = AMBER;
          ctx.fill();
        }

        if (!done) requestAnimationFrame(frame);
      }

      requestAnimationFrame(frame);
    }

    /* ── Newsletter signup ──────────────────────────────────────────── */
    function saveCustomer(email, discountCode) {
      var token  = config.storefrontToken;
      var domain = config.shopDomain;
      if (!token || !domain) return Promise.resolve();

      var pw = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2) + 'Aa1!';

      return fetch('https://' + domain + '/api/2025-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({
          query: 'mutation customerCreate($input:CustomerCreateInput!){customerCreate(input:$input){customer{id}customerUserErrors{code message}}}',
          variables: { input: { email: email, password: pw, acceptsMarketing: true } }
        })
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        // Top-level GraphQL errors (e.g. schema/validation issues) land in
        // data.errors, not customerUserErrors -- log both so a broken
        // mutation never fails silently again.
        if (data && data.errors && data.errors.length) {
          console.warn('[Plinko] customerCreate GraphQL error:', data.errors);
          return;
        }
        var errs = data && data.data && data.data.customerCreate
          ? data.data.customerCreate.customerUserErrors : [];
        if (errs.length && errs[0].code !== 'TAKEN' && errs[0].code !== 'CUSTOMER_DISABLED') {
          console.warn('[Plinko] customerCreate:', errs);
        }
      })
      .catch(function(err) { console.warn('[Plinko] customerCreate request failed:', err); });
    }

    /* ── Wire up UI ─────────────────────────────────────────────────── */
    function init() {
      var inEditor     = window.Shopify && window.Shopify.designMode;
      var alreadySeen  = !inEditor && !!getCookie('skopos_plinko_seen');
      var reopenTab    = document.getElementById('plinko-reopen-tab');
      var reopenLabel  = document.getElementById('plinko-reopen-label');
      var savedCode    = getCookie('skopos_plinko_code');
      var savedAnswer  = getCookie('skopos_quiz_answer');

      // Keep the cart stamped with the won code + quiz answer on every visit
      // while the cookies live (covers carts created after the popup closed).
      stampCartAttributes({ plinko_code: savedCode, focus_type: savedAnswer });

      /* Entry screen: returning winners see their code, visitors who already
         answered the quiz go straight to the board, everyone else gets the quiz. */
      function startScreen() {
        if (savedCode) {
          codeText.textContent = savedCode;
          copyBtn.dataset.code = savedCode;
          showScreen('plinko-screen-code');
        } else if (savedAnswer) {
          showScreen('plinko-screen-game');
          drawIdleBoard(canvas);
        } else {
          showScreen('plinko-screen-quiz');
        }
      }

      // Always keep a way back in, even if the auto-popup was already dismissed.
      if (reopenTab) {
        if (savedCode) reopenLabel.textContent = 'Your code: ' + savedCode;
        reopenTab.hidden = false;
        reopenTab.addEventListener('click', function () {
          openPopup();
          startScreen();
        });
      }

      var backdrop   = document.getElementById('plinko-backdrop');
      var closeBtn   = document.getElementById('plinko-close');
      var skipBtn    = document.getElementById('plinko-skip');
      var canvas     = document.getElementById('plinko-canvas');
      var dropBtn    = document.getElementById('plinko-drop-btn');
      var gameCta    = document.getElementById('plinko-game-cta');
      var resultCard = document.getElementById('plinko-result-card');
      var wonValueEl = document.getElementById('plinko-won-value');
      var claimBtn   = document.getElementById('plinko-claim-btn');
      var prizePill  = document.getElementById('plinko-prize-pill');
      var emailForm  = document.getElementById('plinko-email-form');
      var emailInput = document.getElementById('plinko-email');
      var errorEl    = document.getElementById('plinko-error');
      var submitBtn  = document.getElementById('plinko-submit-btn');
      var codeText   = document.getElementById('plinko-code-text');
      var copyBtn    = document.getElementById('plinko-copy-btn');
      var copyLabel  = document.getElementById('plinko-copy-label');
      var copiedMsg  = document.getElementById('plinko-copied-msg');

      // Close
      function handleClose() { closePopup(); }
      closeBtn.addEventListener('click', handleClose);
      backdrop.addEventListener('click', handleClose);
      skipBtn.addEventListener('click', handleClose);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !popup.hidden) handleClose();
      });

      // Quiz answer → Game. The answer is persisted (cookie + cart attribute)
      // so email flows can segment on it, then the visitor "earns" the drop.
      var quizAnswer = savedAnswer;
      document.querySelectorAll('.plinko-quiz-option').forEach(function (btn) {
        btn.addEventListener('click', function () {
          quizAnswer = btn.dataset.answer || '';
          setCookie('skopos_quiz_answer', quizAnswer, 30);
          stampCartAttributes({ focus_type: quizAnswer });
          showScreen('plinko-screen-game');
          drawIdleBoard(canvas);
        });
      });

      // Drop ball
      dropBtn.addEventListener('click', function () {
        dropBtn.disabled = true;
        runAnimation(canvas, function (actualBucket) {
          wonBucket = actualBucket;
          wonPrize  = PRIZES[wonBucket];
          wonCode   = config.codes[wonBucket] || ('SKOPOS' + wonPrize);
          gameCta.hidden         = true;
          wonValueEl.textContent = wonPrize + '% off';
          resultCard.hidden      = false;
        });
      });

      // Claim → Email
      claimBtn.addEventListener('click', function () {
        prizePill.textContent = wonPrize + '% off';
        showScreen('plinko-screen-email');
        emailInput.focus();
      });

      // Email submit
      emailForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = emailInput.value.trim();

        errorEl.hidden = true;
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          errorEl.textContent = 'Please enter a valid email address.';
          errorEl.hidden = false;
          return;
        }

        submitBtn.disabled    = true;
        submitBtn.textContent = 'Sending…';

        // Stamp the won code + quiz answer onto the cart as custom attributes.
        // They follow the cart into checkout and abandoned-checkout objects,
        // letting Shopify Flow branch recovery emails on discount level and
        // focus segment. (Customer tags via the /contact form are blocked by
        // Shopify's CAPTCHA requirement, so cart attributes are the channel.)
        stampCartAttributes({ plinko_code: wonCode, focus_type: quizAnswer });

        // Also POST Shopify's native customer form with contact[tags] into the
        // hidden iframe — this is the only client-side channel that can put
        // TAGS on the customer at signup (used for welcome-flow segments).
        // Requires the "CAPTCHA on contact and comment forms" preference to be
        // OFF; if it's on, the POST just dies silently in the sink iframe and
        // customerCreate below still guarantees the signup itself.
        try {
          var hiddenForm  = document.getElementById('plinko-subscribe');
          var hiddenEmail = document.getElementById('plinko-hidden-email');
          var hiddenTags  = document.getElementById('plinko-hidden-tags');
          if (hiddenForm && hiddenEmail) {
            hiddenEmail.value = email;
            if (hiddenTags) {
              hiddenTags.value = ['plinko',
                quizAnswer ? 'focus-' + quizAnswer : '',
                wonPrize   ? 'won-' + wonPrize : ''
              ].filter(Boolean).join(',');
            }
            hiddenForm.target = 'plinko-sink';
            hiddenForm.submit();
          }
        } catch (err) { /* non-critical */ }

        saveCustomer(email, wonCode).then(function () {
          codeText.textContent  = wonCode;
          copyBtn.dataset.code  = wonCode;
          showScreen('plinko-screen-code');
          setCookie('skopos_plinko_seen', '1', 30);
          setCookie('skopos_plinko_code', wonCode, 30);
          if (reopenLabel) reopenLabel.textContent = 'Your code: ' + wonCode;
        });
      });

      // Copy
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.dataset.code;
        if (!code) return;

        var finish = function () {
          copyLabel.textContent = 'Copied';
          copyBtn.classList.add('plinko-copy-btn--copied');
          copiedMsg.hidden = false;
          setTimeout(function () {
            copyLabel.textContent = 'Copy';
            copyBtn.classList.remove('plinko-copy-btn--copied');
            copiedMsg.hidden = true;
          }, 2800);
        };

        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(finish);
        } else {
          // Legacy fallback
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.style.cssText = 'position:fixed;opacity:0';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
          finish();
        }
      });

      // Delayed show — only auto-open once; after that visitors use the reopen tab.
      if (!alreadySeen) {
        setTimeout(function () {
          openPopup();
          startScreen();
        }, config.delay);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGallery(section) {
    var carousel = section.querySelector('[data-product-carousel]');
    if (!carousel) return;
    var track = carousel.querySelector('[data-carousel-track]');
    var slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
    if (!track || slides.length < 2) return;
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');
    var dots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));
    var thumbs = Array.from(section.querySelectorAll('[data-carousel-thumb]'));
    var index = 0;
    function setActive(i) {
      index = i;
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); });
      if (prevBtn) prevBtn.disabled = i <= 0;
      if (nextBtn) nextBtn.disabled = i >= slides.length - 1;
    }
    function goTo(i) {
      i = Math.max(0, Math.min(i, slides.length - 1));
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
    }
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== index) setActive(i);
    }, { passive: true });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
    dots.forEach(function (dot, di) { dot.addEventListener('click', function () { goTo(di); }); });
    thumbs.forEach(function (thumb, ti) { thumb.addEventListener('click', function () { goTo(ti); }); });
    setActive(0);
  }

  function initSection(section) {
    initGallery(section);
    section.querySelectorAll('.product-section__accordion-btn').forEach(function (btn) {
      if (btn.classList.contains('product-section__spec-trigger')) return;
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var body = btn.nextElementSibling;
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        body.hidden = expanded;
      });
    });
  }

  document.querySelectorAll('.product-section').forEach(initSection);
})();

(function () {
  document.querySelectorAll('[data-smooth-scroll]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();

(function () {
  function openModal(modal) {
    modal.hidden = false;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    modal.querySelector('.spec-modal__close').focus();
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.product-section__spec-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var modalId = 'spec-modal-' + btn.dataset.specModal;
      var modal = document.getElementById(modalId);
      if (modal) openModal(modal);
    });
  });

  document.querySelectorAll('.spec-modal').forEach(function (modal) {
    modal.querySelectorAll('[data-spec-close]').forEach(function (el) {
      el.addEventListener('click', function () { closeModal(modal); });
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.spec-modal.is-open').forEach(closeModal);
  });
})();

(function () {
  document.querySelectorAll('[data-lifestyle-carousel]').forEach(function (el) {
    var track = el.querySelector('.lifestyle-carousel__track');
    if (!track) return;
    var paused = false;
    function cardWidth() { var card = track.querySelector('.lifestyle-carousel__card'); return card ? card.offsetWidth + 16 : 176; }
    function advance() {
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      if (atEnd) { track.scrollTo({ left: 0, behavior: 'smooth' }); }
      else { track.scrollBy({ left: cardWidth(), behavior: 'smooth' }); }
    }
    setInterval(function () { if (!paused) advance(); }, 5000);
    el.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    el.addEventListener('touchend', function () { paused = false; }, { passive: true });
  });
})();

(function () {
  function root(path) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return base.replace(/\/$/, '') + path;
  }
  document.querySelectorAll('.product-section__atc-btn, .product-sticky-atc__btn').forEach(function (btn) {
    var form = btn.closest('form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;
      fetch(root('/cart/add.js'), { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add-to-cart failed'); return r.json(); })
        .then(function () { document.dispatchEvent(new CustomEvent('cart-drawer:open')); btn.disabled = false; })
        .catch(function () { form.submit(); });
    });
  });
})();

(function () {
  if (!('IntersectionObserver' in window)) return;
  document.querySelectorAll('.product-section').forEach(function (section) {
    var stickyBar = section.querySelector('[data-sticky-atc]');
    var mainBtn = section.querySelector('.product-section__info .product-section__atc-btn');
    if (!stickyBar || !mainBtn) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { stickyBar.classList.toggle('is-hidden', entry.isIntersecting); });
    }, { threshold: 0 });
    observer.observe(mainBtn);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(el) {
      var track = el.querySelector('.ugc-carousel__track');
      var prevBtn = el.querySelector('.ugc-carousel__arrow--prev');
      var nextBtn = el.querySelector('.ugc-carousel__arrow--next');
      if (!track || !prevBtn || !nextBtn) return;

      var timer = null;
      var paused = false;

      function cardWidth() {
        var card = track.querySelector('.ugc-carousel__card');
        return card ? card.offsetWidth + 16 : 316;
      }

      function updateButtons() {
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      }

      function advance() {
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        if (atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
        }
      }

      function startTimer() {
        if (timer) return;
        timer = setInterval(function () {
          if (!paused) advance();
        }, 4000);
      }

      function stopTimer() {
        clearInterval(timer);
        timer = null;
      }

      prevBtn.addEventListener('click', function () {
        stopTimer();
        track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
        startTimer();
      });

      nextBtn.addEventListener('click', function () {
        stopTimer();
        track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
        startTimer();
      });

      el.addEventListener('mouseenter', function () { paused = true; });
      el.addEventListener('mouseleave', function () { paused = false; });
      el.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      el.addEventListener('touchend', function () { paused = false; }, { passive: true });

      track.addEventListener('scroll', updateButtons, { passive: true });
      updateButtons();
      startTimer();
    }

    document.querySelectorAll('.ugc-carousel').forEach(initCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
